import React from 'react';
import { connect } from 'react-redux';
import DefaultEdit from './default-edit';
import { PARTS } from '../../constants/endpoints';
import { UPDATE_PART } from '../../constants/constants';

function EditPart({ _id, title, description, number, state, dispatch }){
  const part_id = _id.$oid;
  const putData = (title, number, description) => ({
    part: {
      title,
      number,
      description,
    }
  });

  var data = {
    sectionTitle: 'Part',
    section_id: part_id,
    endpoint: `${PARTS}/${part_id}`,
    action: UPDATE_PART,
    asyncAction: state.asyncAction,
    putData,
    dispatch,
    title,
    number,
    description,
  };

  return (
    <DefaultEdit {...data} />
  )
}

export default connect(
  nextState => ({ state: nextState })
)(EditPart);
